import React from "react";

export default function DisplayProgressions({ chordsApp }) {
  return (
    <div className="area w-full md:w-2/3 h-screen overflow-y-scroll">
      <div><h5>As notas com fundo branco representam os dedos da mão esquerda, e as outras a direita</h5></div>
      <div id="box" className="flex flex-col">
        {chordsApp.map((item, chave) => (
          <div
            className="p-2 rounded mb-5"
            style={{ backgroundColor: chave % 2 === 0 ? "#f7ebff" : "#EAF6F3" }}
            key={chave}
          >
            <div className="line title_chord"> Tom {item.tom} - progressão: {item.progressao}</div>
            <div className="line">
              {(item.acordes || []).map((acorde, idx) => {
                const colors = ["#C6D6FB", "#F9D5CC", "#FBDDC8", "#C3EFCD"];
                const formula =
                  acorde.formula ||
                  `${acorde.intervalos.left.join(", ")} | ${acorde.intervalos.right.join(", ")}`;
                const [leftHand = acorde.notas || "", rightHand = ""] = (acorde.notas || "").split("|").map((parte) => parte.trim());

                return (
                  <div className="chord" key={idx} style={{ backgroundColor: colors[idx % colors.length] }}>
                    <div>
                      {acorde.rotulo || `Acorde ${acorde.grau}`} -{" "}
                      <span className="text-red-500 font-bold">{acorde.nome || ""}</span>
                    </div>
                    <div className="text-xs font-semibold">{formula}</div>
                    <div className="text-violet-800 font-bold flex flex-wrap items-center gap-2">
                      <span className="bg-white rounded px-2 py-1">{leftHand}</span>
                      <span>|</span>
                      <span>{rightHand}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
